<template>
  <div
    v-if="product"
    :class="{'grey--text lighten-1': disabled}"
    class="brand-text-title"
  >
    <span
      v-if="showQuantity && product.Quantity > 1"
      class="font-weight-bold orange--text"
    >
      {{ product.Quantity }} x
    </span>

    <div
      v-if="product.SpecialStatus && product.IsSpecial"
      class="d-flex align-center"
    >
      <v-icon
        class="mr-1"
        color="brand-green-dark"
        small
      >
        mdi-tag
      </v-icon>

      <span class="brand-text-title brand-green-dark--text">
        {{ productPrice | currency }}
      </span>

      <v-icon color="brand-green-dark lighten-3">
        mdi-arrow-right-thin
      </v-icon>

      <span class="brand-text-title brand-green-dark--text text--lighten-3">
        {{ productSpecialPrice | currency }}
      </span>
    </div>

    <div
      v-else
      class="brand-text-title brand-green-dark--text d-inline-block"
    >
      <template v-if="product.UnitId > 1">
        {{ productUnitBasePriceWithOptions | currency }}
        <span
          class="grey--text text-caption"
        >/ {{ getMeasurementUnitById(product.UnitId).BaseUnit }}</span>
      </template>

      <template v-else>
        {{ productPrice | currency }}
      </template>
    </div>
  </div>
</template>
<script>

import ProductPriceMixin from '@/theme/default/components/product/ProductPrice.js'

export default {
  name  : 'ProductPrice',
  mixins: [ProductPriceMixin]
}
</script>

<style scoped src="@/theme/default/components/product/ProductPrice.css"></style>

<style scoped>
</style>
